(function(){
  'use strict';
  if (window.__ZK_CARD_ATC_SAFE__) return;
  window.__ZK_CARD_ATC_SAFE__ = true;

  function openCart(){
    if (window.ZKCart && typeof window.ZKCart.refreshAndShow === 'function') { window.ZKCart.refreshAndShow(); return; }
    if (typeof window.zkOpenCart === 'function') { window.zkOpenCart(); return; }
    var root = document.getElementById('zk-cart-root');
    if (root) root.classList.add('zk-open');
  }

  document.addEventListener('click', async function(e){
    var btn = e.target.closest('.zk-add-btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-product-id') || btn.getAttribute('data-variant-id');
    if (!id) return;
    var old = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      });
      if (!res.ok) throw new Error('No se pudo agregar al carrito.');
      document.dispatchEvent(new CustomEvent('cart:add'));
      document.dispatchEvent(new CustomEvent('cart:change'));
      openCart();
    } catch (err) {
      console.error('[ZK] Card ATC:', err);
      alert('No se pudo agregar al carrito.');
    } finally {
      btn.disabled = false;
      btn.textContent = old || 'Agregar al carrito';
    }
  }, true);
})();
